import React, { useContext, useEffect } from 'react';
import { StrictMode } from 'react';
import { AuthContext } from './AuthProvider';
import App from './App';
import { redirectToSignIn } from './utils/cliqloanSession';

const MyApp = () => {
  const { isLoggedIn } = useContext(AuthContext);

  useEffect(() => {
    if (!isLoggedIn) {
      redirectToSignIn();
    }
  }, [isLoggedIn]);

  if (!isLoggedIn) {
    return null;
  }

  return (
    <StrictMode>
      <App />
    </StrictMode>
  );
};

export default MyApp;
